import { useAtom } from 'jotai'

import {
  wrap,
  wrapActive,
  closeButton,
  body,
  icon,
  text,
  link,
} from './style'
import { Spacer } from 'components/Spacer'
import { Text03 } from 'components/Typography/Text03'
import { Icon } from 'icons/Icon'
import { Close } from 'images/Close'
import { requestUrlAtom } from 'states'
import { Color } from 'utils/variables'

export const TransitionRequest = () => {
  const [requestUrl, setRequestUrl] = useAtom(requestUrlAtom)

  return (
    <div className={`${wrap} ${requestUrl ? wrapActive : ''}`}>
      <div className={closeButton} onClick={() => setRequestUrl("")}>
        <img src={Close} alt="Close" />
      </div>
      <div className={body}>
        <Icon name="Present" width={27} height={44} className={icon} />
        <Spacer size={13}/>
        <p className={text}>ページ閲覧リクエストが届きました！</p>
        <Spacer size={11}/>
        <a
          href={requestUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={link}
          onClick={() => setTimeout(() => {
            setRequestUrl('')
          }, 500)}
        >
          <Text03 color={Color.Orange}>ページを開く</Text03>
        </a>
      </div>
    </div>
  );
}

